import network from '@/utils/network'
import { agencyPath, createRequestWithComputedFilters, customerPath } from '@/utils/api'
import { MODAL_EVENT_UPDATE_SERVICES } from '@/consts/app'
import { $ui } from '@/utils/ui'

/**
 * Récupère un planning
 * @returns {Promise<>}
 */
export const getAgencyCustomerPlanning = createRequestWithComputedFilters(
  async ({ customer, ...params }) => {
    const slugCustomer = _.isObject(customer) ? customer.slug : customer
    const r = await network.post(`${agencyPath()}/customer/${slugCustomer}/fetch/planning`, params)
    return r.data
  })

/**
 * Récupère un planning
 * @returns {Promise<>}
 */
export const getAgencyCustomersPlanning = createRequestWithComputedFilters(
  async ({ ...params }) => {
    const r = await network.post(`${agencyPath()}${customerPath()}/fetch/planning`, params)
    return r.data
  })

/**
 * Duplique un planning
 * @returns {Promise<[]>}
 */
export const duplicatePlanning = async (params) => {
  const { data = {} } = await network.post(`${agencyPath()}/duplicatePlanning`, params)
  if (data.services && data.services.length) {
    $ui.$emit(MODAL_EVENT_UPDATE_SERVICES, data.services)
  }
  return data
}
